<template>
  <b-toast
    :visible="showError"
    :variant="variant"
    @dismissed="$store.commit('errors/dismissError')"
    >
    <template v-slot:default>{{ message }}</template>
  </b-toast>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState('errors', ['showError', 'variant', 'message'])
}
</script>
